import { EventObserver } from '../util/event-observer'

class OverlayService extends EventObserver {
}

export default new OverlayService()
